/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_DescriptionInputs */

const es_components_credentials_permissions_description = /** @type {(inputs: Components_Credentials_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrá qué usuarios pueden acceder y utilizar esta credencial.`)
};

const en_components_credentials_permissions_description = /** @type {(inputs: Components_Credentials_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage which users can access and use this credential.`)
};

/**
* | output |
* | --- |
* | "Manage which users can access and use this credential." |
*
* @param {Components_Credentials_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_description = /** @type {((inputs?: Components_Credentials_Permissions_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_description(inputs)
	return en_components_credentials_permissions_description(inputs)
});
export { components_credentials_permissions_description as "components.credentials.permissions.description" }